import { render } from "./CollectorAssignmentModal.vue?vue&type=template&id=52c6c17e&scoped=true"
import script from "./CollectorAssignmentModal.vue?vue&type=script&lang=js"
export * from "./CollectorAssignmentModal.vue?vue&type=script&lang=js"

import "./CollectorAssignmentModal.vue?vue&type=style&index=0&id=52c6c17e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c6c17e"]])

export default __exports__